import { memo } from "react";

const MapLayersScreen = () => {
  return <>Danh sách lớp</>
}

export default memo(MapLayersScreen);